import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Services = () => {
  const services = [
    {
      icon: '💡',
      title: 'Business Capital Consulting',
      description: 'Comprehensive advisory services to help you understand and navigate various business funding options.',
      features: [
        'Funding needs assessment',
        'Capital structure analysis',
        'Financing strategy development',
        'Risk evaluation and mitigation'
      ]
    },
    {
      icon: '📋',
      title: 'Funding Preparation Assistance',
      description: 'Expert support in preparing your business for funding applications and lender requirements.',
      features: [
        'Application readiness review',
        'Business plan refinement',
        'Financial projections preparation',
        'Presentation materials development'
      ]
    },
    {
      icon: '📄',
      title: 'Financial Documentation Support',
      description: 'Professional assistance in organizing and presenting your financial records effectively.',
      features: [
        'Document organization and review',
        'Financial statement preparation',
        'Tax return analysis',
        'Supporting documentation compilation'
      ]
    },
    {
      icon: '🔍',
      title: 'Lender Matching Guidance',
      description: 'Strategic guidance to connect you with financial institutions that align with your business needs.',
      features: [
        'Lender research and evaluation',
        'Matching criteria analysis',
        'Introduction facilitation',
        'Relationship management support'
      ]
    },
    {
      icon: '✅',
      title: 'Funding Feasibility Review',
      description: 'Thorough assessment of your funding readiness and likelihood of approval.',
      features: [
        'Credit profile evaluation',
        'Business health assessment',
        'Qualification analysis',
        'Improvement recommendations'
      ]
    },
    {
      icon: '📈',
      title: 'Business Growth & Financing Strategy',
      description: 'Long-term strategic planning to support sustainable business expansion and capital management.',
      features: [
        'Growth strategy development',
        'Capital allocation planning',
        'Financial milestone setting',
        'Ongoing advisory support'
      ]
    }
  ];

  return (
    <>
      <Helmet>
        <title>Our Services - Miranda Landa Services LLC | Business Capital Advisory</title>
        <meta name="description" content="Comprehensive business capital consulting services including funding preparation, financial documentation support, lender matching, and strategic growth planning." />
      </Helmet>

      {/* Hero Section */}
      <section style={{
        background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
        color: 'white',
        padding: '5rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{maxWidth: '800px', margin: '0 auto'}}>
          <h1 style={{fontSize: '3rem', fontWeight: '800', marginBottom: '1.5rem'}}>
            Our Services
          </h1>
          <p style={{fontSize: '1.3rem', opacity: 0.95, lineHeight: '1.6'}}>
            Comprehensive business capital consulting and strategic funding advisory services
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section style={{padding: '5rem 2rem', background: 'white'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <div style={{textAlign: 'center', marginBottom: '4rem'}}>
            <h2 style={{fontSize: '2.5rem', fontWeight: '800', color: '#064e3b', marginBottom: '1rem'}}>
              Complete Capital Advisory Solutions
            </h2>
            <p style={{fontSize: '1.2rem', color: '#6b7280', maxWidth: '700px', margin: '0 auto'}}>
              We provide end-to-end support for businesses seeking funding opportunities
            </p>
          </div>

          <div style={{display: 'grid', gap: '3rem'}}>
            {services.map((service, index) => (
              <div key={index} className="card" style={{
                display: 'grid',
                gridTemplateColumns: 'auto 1fr',
                gap: '2rem',
                alignItems: 'start'
              }}>
                <div style={{
                  fontSize: '4rem',
                  background: 'linear-gradient(135deg, #f0fdf4 0%, #d1fae5 100%)',
                  width: '100px',
                  height: '100px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '16px'
                }}>
                  {service.icon}
                </div>
                <div>
                  <h3 style={{fontSize: '1.8rem', fontWeight: '700', color: '#059669', marginBottom: '1rem'}}>
                    {service.title}
                  </h3>
                  <p style={{fontSize: '1.1rem', color: '#6b7280', lineHeight: '1.7', marginBottom: '1.5rem'}}>
                    {service.description}
                  </p>
                  <div style={{
                    background: '#f9fafb',
                    padding: '1.5rem',
                    borderRadius: '8px',
                    borderLeft: '3px solid #10b981',
                    marginBottom: '1.5rem'
                  }}>
                    <h4 style={{fontSize: '1rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
                      What's Included:
                    </h4>
                    <ul style={{
                      listStyle: 'none',
                      padding: 0,
                      display: 'grid',
                      gap: '0.75rem'
                    }}>
                      {service.features.map((feature, fIndex) => (
                        <li key={fIndex} style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.75rem',
                          color: '#4b5563'
                        }}>
                          <span style={{color: '#10b981', fontSize: '1.2rem', fontWeight: '800'}}>✓</span>
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                  {index === 0 && (
                    <Link to="/services/business-capital-consulting" style={{
                      background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
                      color: 'white',
                      padding: '0.75rem 2rem',
                      borderRadius: '50px',
                      fontWeight: '600',
                      fontSize: '1rem',
                      display: 'inline-block'
                    }}>
                      Learn More →
                    </Link>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section style={{padding: '5rem 2rem', background: '#f9fafb'}}>
        <div style={{maxWidth: '1000px', margin: '0 auto'}}>
          <div style={{textAlign: 'center', marginBottom: '3rem'}}>
            <h2 style={{fontSize: '2.5rem', fontWeight: '800', color: '#064e3b', marginBottom: '1rem'}}>
              Our Consultation Process
            </h2>
            <p style={{fontSize: '1.2rem', color: '#6b7280'}}>
              A structured approach to preparing your business for funding success
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '2rem'
          }}>
            {[
              {
                step: '01',
                title: 'Discovery Call',
                desc: 'We learn about your business, goals, and funding requirements'
              },
              {
                step: '02',
                title: 'Assessment',
                desc: 'Comprehensive evaluation of your current financial position and readiness'
              },
              {
                step: '03',
                title: 'Strategy Development',
                desc: 'Create a customized funding preparation and approach strategy'
              },
              {
                step: '04',
                title: 'Documentation',
                desc: 'Organize and prepare all necessary financial and business documents'
              },
              {
                step: '05',
                title: 'Lender Connection',
                desc: 'Introduction to appropriate financial institutions for your needs'
              },
              {
                step: '06',
                title: 'Ongoing Support',
                desc: 'Continued guidance throughout the funding process'
              }
            ].map((item, index) => (
              <div key={index} style={{
                background: 'white',
                padding: '2rem',
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                textAlign: 'center'
              }}>
                <div style={{
                  background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
                  color: 'white',
                  fontSize: '1.5rem',
                  fontWeight: '800',
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 1.5rem'
                }}>
                  {item.step}
                </div>
                <h3 style={{fontSize: '1.3rem', fontWeight: '700', color: '#064e3b', marginBottom: '0.75rem'}}>
                  {item.title}
                </h3>
                <p style={{color: '#6b7280', lineHeight: '1.6'}}>
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Work With Us */}
      <section style={{padding: '5rem 2rem', background: 'white'}}>
        <div style={{maxWidth: '1000px', margin: '0 auto'}}>
          <div style={{textAlign: 'center', marginBottom: '3rem'}}>
            <h2 style={{fontSize: '2.5rem', fontWeight: '800', color: '#064e3b', marginBottom: '1rem'}}>
              Why Businesses Choose Us
            </h2>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '2rem'
          }}>
            {[
              { icon: '🎯', title: 'Focused Expertise', desc: 'Specialized in business capital consulting and funding preparation' },
              { icon: '🤝', title: 'Trusted Partners', desc: 'Work only with verified, reputable financial institutions' },
              { icon: '📊', title: 'Data-Driven', desc: 'Strategic approach based on thorough analysis and market insights' },
              { icon: '⚡', title: 'Efficient Service', desc: 'Streamlined process to get you funding-ready quickly' },
              { icon: '🔒', title: 'Confidential', desc: 'Your business information is protected and secure' },
              { icon: '💼', title: 'Professional', desc: 'Experienced consultants dedicated to your success' }
            ].map((item, index) => (
              <div key={index} style={{
                background: '#f0fdf4',
                padding: '2rem',
                borderRadius: '12px',
                textAlign: 'center'
              }}>
                <div style={{fontSize: '3rem', marginBottom: '1rem'}}>{item.icon}</div>
                <h3 style={{fontSize: '1.2rem', fontWeight: '700', color: '#059669', marginBottom: '0.75rem'}}>
                  {item.title}
                </h3>
                <p style={{color: '#6b7280', fontSize: '0.95rem', lineHeight: '1.6'}}>
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Important Notice */}
      <section style={{
        background: '#fef3c7',
        padding: '3rem 2rem',
        borderTop: '3px solid #f59e0b',
        borderBottom: '3px solid #f59e0b'
      }}>
        <div style={{maxWidth: '900px', margin: '0 auto', textAlign: 'center'}}>
          <h3 style={{fontSize: '1.5rem', fontWeight: '700', color: '#92400e', marginBottom: '1rem'}}>
            ⚠️ Important Disclosure
          </h3>
          <p style={{fontSize: '1.1rem', color: '#78350f', lineHeight: '1.7'}}>
            Miranda Landa Services LLC provides financial consultation only. We do not offer loans or make credit decisions. 
            All lending terms, approval decisions, and funding are determined by the financial institutions we connect you with. 
            We are a consulting firm, not a lender.
          </p>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        background: 'linear-gradient(135deg, #064e3b 0%, #059669 100%)',
        color: 'white',
        padding: '5rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{maxWidth: '700px', margin: '0 auto'}}>
          <h2 style={{fontSize: '2.5rem', fontWeight: '800', marginBottom: '1.5rem'}}>
            Ready to Get Started?
          </h2>
          <p style={{fontSize: '1.2rem', marginBottom: '2.5rem', opacity: 0.95}}>
            Schedule your consultation and take the first step toward securing business funding
          </p>
          <Link to="/contact" style={{
            background: 'white',
            color: '#059669',
            padding: '1.25rem 3rem',
            borderRadius: '50px',
            fontWeight: '700',
            fontSize: '1.2rem',
            display: 'inline-block',
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
          }}>
            Contact Us Today
          </Link>
          <p style={{marginTop: '1.5rem', fontSize: '0.9rem', opacity: 0.8}}>
            ✓ Free initial consultation • ✓ No obligation • ✓ Confidential discussion
          </p>
        </div>
      </section>
    </>
  );
};

export default Services;
